import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Configure18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.25 3.5C8.25 2.80964 8.80964 2.25 9.5 2.25H13.5C14.1904 2.25 14.75 2.80964 14.75 3.5V4.25H18V5.75H14.75V6.5C14.75 7.19036 14.1904 7.75 13.5 7.75H9.5C8.80964 7.75 8.25 7.19036 8.25 6.5V5.75H0V4.25H8.25V3.5ZM9.75 3.75V6.25H13.25V3.75H9.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.25 12.25H0V13.75H3.25V14.5C3.25 15.1904 3.80964 15.75 4.5 15.75H8.5C9.19036 15.75 9.75 15.1904 9.75 14.5V13.75H18V12.25H9.75V11.5C9.75 10.8096 9.19036 10.25 8.5 10.25H4.5C3.80964 10.25 3.25 10.8096 3.25 11.5V12.25ZM8.25 11.75V14.25H4.75V11.75H8.25Z'
      fill='currentColor'
    />
  </Svg>
);

Configure18.displayName = 'Configure18';
export default Configure18;
